export default function SectionHeader({ kicker, title, description, align = "right", testId }) {
  const alignClass = align === "center" ? "text-center mx-auto" : "text-right";
  return (
    <div className={`max-w-3xl ${alignClass} mb-12 md:mb-16`} data-testid={testId}>
      {kicker && (
        <p className="font-heading text-xs md:text-sm font-bold tracking-[0.3em] text-[#DC2626] uppercase mb-3">
          {kicker}
        </p>
      )}
      <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-black text-white uppercase tracking-tight leading-[0.95]">
        {title}
      </h2>
      {description && (
        <p className="font-body text-base md:text-lg text-neutral-400 mt-5 leading-relaxed">
          {description}
        </p>
      )}
    </div>
  );
}
